import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'tr',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    resources: {
      tr: {
        translation: {
          // Common
          loading: 'Yükleniyor...',
          save: 'Kaydet',
          cancel: 'İptal',
          delete: 'Sil',
          edit: 'Düzenle',
          add: 'Ekle',
          search: 'Ara',
          filter: 'Filtrele',
          export: 'Dışa Aktar',
          total: 'Toplam',
          actions: 'İşlemler',
          status: 'Durum',
          date: 'Tarih',
          name: 'Ad',
          email: 'E-posta',
          phone: 'Telefon',
          address: 'Adres',
          description: 'Açıklama',
          common: {
            tutorial: 'Öğretici',
            loading: 'Yükleniyor...',
            save: 'Kaydet',
            cancel: 'İptal',
            delete: 'Sil',
            edit: 'Düzenle',
            add: 'Ekle',
            search: 'Ara',
            filter: 'Filtrele',
            export: 'Dışa Aktar',
            total: 'Toplam',
            actions: 'İşlemler',
            status: 'Durum',
            date: 'Tarih',
            name: 'Ad',
            email: 'E-posta',
            phone: 'Telefon',
            address: 'Adres',
            description: 'Açıklama',
            refresh: 'Yenile',
            clear_filters: 'Filtreleri Temizle',
            open: 'Açık',
            closed: 'Kapalı',
            active: 'Aktif',
            inactive: 'Pasif',
            all: 'Tümü',
            no_permission: 'Bu sayfayı görüntülemeye izniniz yoktur.'
          },
          footer: {
            brand_notice: "İnohom, GST ELEKTRONİK AŞ'nin tescilli markasıdır. Telif hakkı ©2012-{{year}}. Tüm hakları saklıdır.",
            version: 'Sürüm {{version}}'
          },
          common: {
            loading: 'Yükleniyor...',
            save: 'Kaydet',
            cancel: 'İptal',
            delete: 'Sil',
            edit: 'Düzenle',
            add: 'Ekle',
            search: 'Ara',
            filter: 'Filtrele',
            export: 'Dışa Aktar',
            total: 'Toplam',
            actions: 'İşlemler',
            status: 'Durum',
            date: 'Tarih',
            name: 'Ad',
            email: 'E-posta',
            phone: 'Telefon',
            address: 'Adres',
            description: 'Açıklama',
            refresh: 'Yenile',
            clear_filters: 'Filtreleri Temizle',
            open: 'Açık',
            closed: 'Kapalı',
            no_permission: 'Bu sayfayı görüntülemeye izniniz yoktur.'
          },
          widgets: {
            quickStats: 'Hızlı İstatistikler',
            chartWidget: 'Grafik Bileşeni',
            taskWidget: 'Görev Bileşeni',
            recentActivities: 'Son Aktiviteler',
            ticketStatusDistribution: 'İş Emri Durum Dağılımı',
            performanceMetrics: 'Performans Metrikleri',
            customerSatisfaction: 'Müşteri Memnuniyeti',
            salesData: 'Satış Verileri',
            chart: 'Grafik',
            tasks: 'Görevler'
          },
          
          // Navigation (added nested keys for top bar)
          navigation: {
            dashboard: 'Ana Sayfa',
            management: 'Yönetim',
            employees: 'Personel',
            customers: 'Müşteriler',
            projects: 'Projeler',
            resellers: 'Bayiler',
            operations: 'Operasyonlar',
            tickets: 'İş Emirleri',
            completedTickets: 'Tamamlanmış İş Emirleri',
            tasks: 'Görevler',
            appointments: 'Randevular',
            services: 'Servisler',
            serviceForms: 'Servis Formları',
            quickActions: 'Hızlı İşlemler',
            newTicket: 'Yeni İş Emri',
            reports: 'Raporlar',
            analytics: 'Analizler'
          },
          
          // Navigation
          dashboard: 'Ana Sayfa',
          tickets: 'Biletler',
          tasks: 'Görevler',
          employees: 'Personeller',
          customers: 'Müşteriler',
          resellers: 'Bayiler',
          projects: 'Projeler',
          services: 'Servisler',
          units: 'Birimler',
          notes: 'Notlar',
          users: 'Kullanıcılar',
          logs: 'Loglar',
          settings: 'Ayarlar',
          
          // Ticket states
          states: {
            assignment: 'Atama Bekliyor',
            cancelled: 'İptal Edildi',
            deleted: 'SİLİNDİ',
            failed: 'Servis Başarısız',
            in_queue: 'Kuyrukta',
            in_progress: 'İşlemde',
            approval: 'Onay Bekliyor',
            completed: 'Tamamlandı',
            pending: 'Beklemede',
            sent_to_base: 'Servise gönderiliyor',
            sent_to_reseller: 'Bayiye gönderiliyor',
            received_by_base: 'Servise ulaştı',
            received_by_reseller: 'Bayiye ulaştı',
            eval_started: 'İnceleniyor',
            pending_for_coverage: 'Hizmet tutarı belirleniyor',
            customer_accepted: 'Onarım ücreti müşteri tarafından onaylandı',
            customer_rejected: 'Onarım ücreti müşteri tarafından onaylanmadı',
          },
          
          // Ticket kinds
          kinds: {
             education: 'Eğitim',
             initialization: 'Başlatım',
             installation: 'Kurulum',
             assembly: 'Montaj',
             malfunction: 'Arıza',
             replacement: 'Değişim',
             maintenance: 'Bakım',
             construction_site_control: 'İnşaat Saha Kontrolü',
             infrastructure_control: 'Altyapı Kontrol',
             request: 'Talep',
             other: 'Diğer',
           },
          
          // Priority levels
          priority: {
            low: 'Düşük',
            medium: 'Orta',
            high: 'Yüksek',
          },
          
          // Status labels
          status: {
            new: 'Yeni',
            assigned: 'Atandı',
            in_progress: 'Devam Ediyor',
            completed: 'Tamamlandı',
            cancelled: 'İptal Edildi',
            unknown: 'Bilinmiyor',
          },
          
          // Messages
          messages: {
            customer_not_found_or_phone_not_verified: 'Müşteri bulunamadı veya telefon numarası onaylı değil.',
            data_loading_error: 'Veriler yüklenirken bir hata oluştu.',
            copied: 'Kopyalandı',
            message_template_copied: 'Mesaj şablonu panoya kopyalandı',
            error: 'Hata',
            clipboard_copy_failed: 'Panoya kopyalama başarısız oldu. Lütfen metni manuel kopyalayın.',
            success: 'Başarılı',
            operation_failed: 'İşlem gerçekleştirilemedi.',
            ticket_deleted: 'İş emri silindi.',
            ticket_started: 'İş emri başlatıldı',
            ticket_completed: 'İş emri tamamlandı',
            ticket_cancelled: 'İş emri iptal edildi.',
            service_form_saved: 'Servis formu başarıyla kaydedildi',
            processing_operation: 'İşlem gerçekleştiriliyor...',
          },
          
          // Buttons
          buttons: {
            send_message_copy_to_clipboard: 'Mesaj Gönder (Panoya Kopyala)',
          },
          
          // Validation messages
          validation: {
            phone_required: 'Telefon numarası gereklidir',
            phone_10_digits: 'Telefon numarası 10 haneli olmalıdır',
            phone_start_with_5: 'Telefon numarası 5 ile başlamalıdır',
          },
          
          // Forms
          forms: {
            phone_number: 'Telefon Numarası',
          },
          
          // Tickets
          tickets: {
            created_successfully: 'İş Emriniz Oluşturuldu',
            tracking_message: 'Bu takip numarası ile istediğiniz zaman servis kaydınızın durumunu takip edebilirsiniz',
            go_to_query: 'Buraya tıklayarak sorgulama ekranına gidebilirsiniz.',
            create_ticket: 'İş Emri Oluştur',
            create_new_service_request: 'İş emri listesi',
          },
          
          ticket: {
            header: {
              title: 'Başlık',
              status_label: 'Durum',
              customer_label: 'Müşteri',
              reseller_label: 'Bayi',
              unit_label: 'Ünite',
              created_label: 'Oluşturulma',
              change: 'Değiştir',
              assign: 'Ata',
              unassigned: 'Atanmamış',
              date_not_specified: 'Tarih belirtilmemiş'
            },
            tasks: {
              title: 'Görevler',
              subtitle: 'Ticket ile ilgili görevler',
              add_bulk: 'Çoklu Görev Ekle',
              add_subtask: 'Alt Görev Ekle',
              go_to_work_order: 'İş Emrine Çık'
            },
            statistics: {
              load_error: 'İstatistik verileri yüklenemedi',
              missing_date_info: 'Ticket tarih bilgileri eksik',
              open_duration: 'Açık Süre',
              last_update: 'Son Güncelleme',
              priority_label: 'Öncelik',
              progress_label: 'İlerleme',
              time_analysis: 'Zaman Analizi',
              performance_metrics: 'Performans Metrikleri',
              estimated_completion: 'Tahmini Tamamlanma',
              created: 'Oluşturulma',
              assigned_person: 'Atanan Kişi',
              task_count: 'Görev Sayısı',
              note_count: 'Not Sayısı',
              update_count: 'Güncelleme',
              overdue_warning_title: 'Süre Aşımı Uyarısı',
              overdue_warning_desc: 'Bu ticket tahmini tamamlanma süresini aştı. Öncelik verilmesi önerilir.'
            },
            timeline: {
              current_status: 'Mevcut Durum:',
              ticket_created: 'Ticket Oluşturuldu',
              ticket_assigned: 'Ticket Atandı',
              unit_assigned: 'Birim Atandı',
              ticket_started: 'Ticket Başlatıldı',
              ticket_completed: 'Ticket Tamamlandı',
              ticket_cancelled: 'Ticket İptal Edildi',
              created_desc: 'tarafından oluşturuldu',
              assigned_reseller_desc: 'bayisine atandı',
              assigned_unit_desc: 'birimine atandı',
              started_desc: 'İş emri işleme alındı',
              completed_desc: 'İş emri başarıyla tamamlandı',
              cancelled_desc: 'İş emri iptal edildi'
            },
            templates: {
              select_title: 'Template Seçin',
              select_subtitle: 'Bir ticket template seçin',
              load_error: 'Şablonlar yüklenemedi',
              not_selected: 'Şablon seçilmedi',
              pdf_generated: 'PDF oluşturuldu',
              docx_generated: 'DOCX oluşturuldu',
              pdf_error: 'PDF oluşturma hata',
              docx_error: 'DOCX oluşturma hata'
            },
            form_labels: {
              customer_full_name: 'Müşteri Adı Soyadı',
              customer_address: 'Müşteri Adresi',
              customer_phone: 'Müşteri Telefon',
              customer_email: 'Müşteri E-posta',
              faulty_product: 'Arızalı Ürün',
              fault: 'Arıza',
              description: 'Açıklama',
              unit: 'Birim',
              product_name: 'Ürün Adı',
              serial_number: 'Seri No'
            },
            activity_history: 'Aktivite Geçmişi'
          },
          
          customer: {
            customer: "Müşteri",
            contact: "İletişim",
            reseller: "Bayi",
            status: "Durum",
            actions: "İşlemler",
            unassigned: "Atanmamış",
            view_details: "Detayları Görüntüle",
            edit: "Düzenle",
            delete: "Sil",
            name: "İsim",
            phone: "Telefon",
            city: "Şehir",
            verified: "Onaylı",
            customer_management: "Müşteri Yönetimi",
            customers_displayed: "müşteri görüntüleniyor",
            customers: "Müşteriler",
            new_customer: "Yeni Müşteri",
            navigation_next: "İleri",
            navigation_back: "Geri",
            search_customer: "Müşteri ara...",
            all_statuses: "Tüm Durumlar",
            unverified: "Onaylanmamış",
            no_customers_found: "Arama kriterlerine uygun müşteri bulunamadı",
            no_customers_yet: "Gösterilecek veri yok",
            try_different_search: "Farklı arama terimleri deneyin",
            add_first_customer_hint: "İlk müşterinizi eklemek için yukarıdaki butonu kullanın",
            add_first_customer: "İlk Müşteriyi Ekle"
          },
          
          // Dashboard
          dashboard_summary: 'Özet',
          dashboard_total_page: 'Toplam Sayfa',
          management_dashboard: 'Yönetim Paneli',
          general_statistics: 'Genel İstatistikler',
          total_tickets: 'Toplam İş Emri',
          task_count: 'Görev Sayısı',
          customer_count: 'Müşteri Sayısı',
          employee_count: 'Personel Sayısı',
          ticket_status_distribution: 'İş Emri Durum Dağılımı (%)',
          
          // Dashboard statistics
          navigation_back: "Geri",
          navigation_next: "İleri",
          total_customers: "Toplam Müşteri",
          total_tickets: "Toplam Bilet",
          open_tickets: "Açık Biletler",
          closed_tickets: "Kapalı Biletler",
          
          // Employee translations
          employee: {
            employee_management: "Personel Yönetimi",
            team_members_info: "Ekip üyeleri ve takım bilgileri",
            create_team: "Takım Oluştur",
            add_employee: "Personel Ekle",
            name: "Ad Soyad",
            dealer: "Bayi",
            dealer_manager: "Bayi Yöneticisi?",
            employee_action: "Personel Aksiyon",
            team: "Takım",
            team_leader: "Takım Lideri?",
            team_action: "Takım Aksiyon",
            availability: "Meşguliyet",
            add_to_team: "Takıma Ekle",
            remove_from_team: "Takımdan Kaldır",
            no_employees_yet: "Henüz personel kaydı bulunmuyor",
            add_first_employee_hint: "İlk personeli eklemek için yukarıdaki butonu kullanın",
            employee_removed_from_team: "Personel takımdan çıkartıldı",
            remove_from_team_failed: "Takımdan çıkarma işlemi başarısız oldu",
            roles: "Roller",
            teams: "Takımlar",
            person_info: "Personel Bilgileri",
            manager_label: "Yönetici",
            worker_label: "Personel",
            team_leader_label: "Takım Lideri",
            no_team: "Takımsız",
            login_permission: "Giriş İzni",
            role: "Personel Yetkisi ",
            login_permission_enabled: "Giriş izni açıldı",
            login_permission_disabled: "Giriş izni kapatıldı",
            no_employees_found: "Arama kriterlerine uygun personel bulunamadı",
            search_employee: "Personel ara...",
            make_manager: "Yönetici yap",
            remove_manager_privilege: "Yönetici yetkisini kaldır",
            toggle_servicer_status: "Servisçi durumunu değiştir",
            send_credentials: "Bilgilerini Gönder",
            send_credentials_success: "Giriş bilgileri SMS olarak gönderildi",
            send_credentials_failed: "Giriş bilgileri gönderilemedi"
          },
          login: {
            title: 'Giriş Yap',
            back: 'Geri dön',
            subtitle: 'Kullanıcı adınızı girin ve SMS doğrulaması ile giriş yapın.',
            username: 'Kullanıcı Adı',
            username_placeholder: 'Kullanıcı adınız',
            reseller_code: 'Bayi Kodu',
            reseller_code_placeholder: 'Bayi kodu',
            sms_code: 'SMS Kod',
            sms_code_placeholder: 'SMS ile gelen kod',
            twofa_hint_sms: 'Kod SMS ile gönderildi, SMS’i kontrol edin.',
            twofa_hint_email: 'Kod e-posta ile gönderildi, e-postayı kontrol edin.',
            remember_me: 'Beni hatırla',
            continue: 'Devam Et',
            verify_sms: 'Giris Yap',
            resend_sms: 'Tekrar Gönder',
            try_sms: 'SMS ile dene',
            try_email: 'E-posta ile dene',
            username_help: 'Kullanıcı adınızı girin ve devam edin.',
            reseller_code_help: 'Bayi kodunu girin.',
            sms_resend_success: 'SMS tekrar gönderildi',
            email_resend_success: 'E-posta tekrar gönderildi',
            errors: {
              username_required: 'Kullanıcı adını girin.',
              reseller_code_required: 'Bayi kodunu girin.',
              sms_code_required: 'SMS kodunu girin.',
              invalid_username: 'Kullanıcı adı hatalı.',
              sms_verification_failed: 'Doğrulama başarısız.',
              sms_resend_failed: 'SMS gönderilemedi.',
              email_resend_failed: 'E-posta gönderilemedi.'
            },
            admin: {
              title: 'Bayi Yönetimi',
              city: 'Şehir',
              new_reseller: 'Yeni Bayi',
              move_to_root_hint: 'Köke taşımak için buraya bırakın (üst bayi yok)',
              move_to_root_label: 'Köke Taşı (Üst Bayi: Yok)',
              table: {
                name: 'Ad',
                cities: 'Şehirler',
                open_ticket: 'Açık Ticket',
                managers: 'Yöneticiler',
                status: 'Durum'
              },
              drag_assign_hint: 'Üst bayi atamak için başka bir bayinin üzerine sürükleyip bırakın',
              deactivate: 'Devre Dışı',
              activate: 'Aktif Et',
              edit_reseller: 'Bayi Düzenle',
              create: 'Oluştur',
              export: {
                filename: 'bayiler_admin',
                sheet_name: 'Bayiler',
                columns: {
                  id: 'ID',
                  name: 'Ad',
                  cities: 'Şehirler',
                  open_ticket: 'Açık Ticket',
                  managers: 'Yöneticiler',
                  status: 'Durum'
                }
              }
            }
          },
          project: {
        project_management: "Proje Yönetimi",
        active_projects_info: "Aktif projeler ve ilerleme durumları",
        add_project: "Proje Ekle",
        search_project: "Proje ara...",
        all: "Tümü",
        active: "Aktif",
        completed: "Tamamlanan",
        unit_count: "Birim Sayısı",
        completion: "Tamamlanma",
        work_orders: "İş Emirleri",
        open: "Açık",
        closed: "Kapalı",
        no_projects_found: "Arama kriterlerine uygun proje bulunamadı",
        no_projects_yet: "Henüz proje kaydı bulunmuyor",
        try_different_search: "Farklı arama terimleri deneyin",
        add_first_project_hint: "İlk projenizi eklemek için yukarıdaki butonu kullanın"
      },
      task: {
        type: "TİP",
        title: "Başlık",
        team: "Takım",
        created_date: "Oluşturulma Tarihi",
        appointment: "Randevu",
        status: "Durum",
        progress_expectation: "İlerleme Beklentisi",
        total_tasks: "Toplam {{count}} görev"
      },
      service: {
        unit: "ÜNİTE",
        unit_label: "Ünite",
        faulty_products: "Üniteye ait arızalı ürünler",
        faulty_products_count: "{{count}} Adet Arızalı Ürün",
        no_service_record: "Servis Kaydı Yok",
        click_for_details: "Detayları görüntülemek için tıklayın",
        device: "CİHAZ",
        type: "TİPİ",
        description: "AÇIKLAMA",
        status: "DURUM",
        service_management: "Servis Yönetimi",
        active_service_records: "Aktif servis kayıtları ve arızalı ürünler",
        no_service_records_yet: "Henüz servis kaydı bulunmuyor",
        new_work_orders_appear_here: "Yeni iş emirleri burada görünecektir"
      },
          
          // Project kinds
          projectKinds: {
            collective: 'Toplu Konut',
            villa: 'Villa',
            factory: 'Fabrika',
            office: 'Ofis',
            hotel: 'Otel',
            eatery: 'Yemekhane',
            bs_center: 'İş Merkezi',
            pl_bldng: 'Kamu Binası',
            sp_center: 'Alışveriş Merkezi',
            other: 'Diğer',
          },
          
          // Service types
          serviceTypes: {
            renovation: 'Tamir/onarım',
            replacement: 'Değişim',
            maintenence: 'Bakım',
          },
          
          // Coverage
          coverage: {
            guarantee: 'Garanti Kapsamı',
            customer: 'Kullanıcı hatası (Müşteri)',
            reseller: 'Kurulum hatası (Bayi)',
          },

          reseller: {
            management_system_title: 'Bayi Yönetim Sistemi',
            management_system_subtitle: 'Tüm bayilerinizi ve iş emirlerini tek yerden yönetin',
            total_resellers: 'Toplam Bayi',
            active_resellers: 'Aktif Bayi',
            open_work_orders: 'Açık İş Emri',
            manager_summary: 'Yönetici Özeti',
            level_main: 'Ana Bayi',
            level_region: 'Bölge Bayisi',
            level_sub: 'Alt Bayi',
            expand_all: 'Hepsini Genişlet',
            collapse_all: 'Hepsini Daralt',
            expand: 'Genişlet',
            collapse: 'Daralt',
            open_tickets: 'Açık İş Emirleri',
            team_count: 'Takım Sayısı',
            manager_title: 'Bayi Yöneticisi',
            phone_number_title: 'Bayi Telefon Numarası',
            address_title: 'Bayi Adresi',
            modal_manager_summary_title: 'Bayi Yöneticisi Özeti',
            modal_total_resellers: 'Toplam Bayi',
            modal_total_managers: 'Toplam Yönetici',
            modal_resellers_without_manager: 'Yöneticisi Olmayan Bayi',
            resellers_without_managers_title: 'Yöneticisi Olmayan Bayiler',
            manager_count_by_reseller: 'Bayi Bazlı Yönetici Sayıları',
            reseller: 'Bayi',
            manager_count: 'Yönetici Sayısı',
            close: 'Kapat',
            export: {
              filename: 'bayiler',
              sheet_name: 'Bayiler',
              columns: {
                reseller: 'Bayi',
                level: 'Seviye',
                phone: 'Telefon',
                address: 'Adres',
                city: 'Şehir',
                open_work_order: 'Açık İş Emri',
                team_count: 'Takım Sayısı',
                manager_count: 'Yönetici Sayısı'
              }
            }
          },
        }
      },
      en: {
        translation: {
          // Common
          loading: 'Loading...',
          save: 'Save',
          cancel: 'Cancel',
          delete: 'Delete',
          edit: 'Edit',
          add: 'Add',
          search: 'Search',
          filter: 'Filter',
          export: 'Export',
          total: 'Total',
          actions: 'Actions',
          status: 'Status',
          date: 'Date',
          name: 'Name',
          email: 'Email',
          phone: 'Phone',
          address: 'Address',
          description: 'Description',
          common: {
            tutorial: 'Tutorial',
            loading: 'Loading...',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            edit: 'Edit',
            add: 'Add',
            search: 'Search',
            filter: 'Filter',
            export: 'Export',
            total: 'Total',
            actions: 'Actions',
            status: 'Status',
            date: 'Date',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            address: 'Address',
            description: 'Description',
            refresh: 'Refresh',
            clear_filters: 'Clear Filters',
            open: 'Open',
            closed: 'Closed',
            active: 'Active',
            inactive: 'Inactive',
            all: 'All',
            no_permission: 'You do not have permission to view this page.'
          },
          footer: {
            brand_notice: 'Inohom is a registered trademark of GST ELEKTRONİK AŞ. Copyright ©2012-{{year}}. All rights reserved.',
            version: 'Version {{version}}'
          },
          common: {
            loading: 'Loading...',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            edit: 'Edit',
            add: 'Add',
            search: 'Search',
            filter: 'Filter',
            export: 'Export',
            total: 'Total',
            actions: 'Actions',
            status: 'Status',
            date: 'Date',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            address: 'Address',
            description: 'Description',
            refresh: 'Refresh',
            clear_filters: 'Clear Filters',
            open: 'Open',
            closed: 'Closed',
            no_permission: 'You do not have permission to view this page.'
          },
          widgets: {
            quickStats: 'Quick Stats',
            chartWidget: 'Chart Widget',
            taskWidget: 'Task Widget',
            recentActivities: 'Recent Activities',
            ticketStatusDistribution: 'Ticket Status Distribution',
            performanceMetrics: 'Performance Metrics',
            customerSatisfaction: 'Customer Satisfaction',
            salesData: 'Sales Data',
            chart: 'Chart',
            tasks: 'Tasks'
          },
          
          // Navigation (added nested keys for top bar)
          navigation: {
            dashboard: 'Dashboard',
            management: 'Management',
            employees: 'Employees',
            customers: 'Customers',
            projects: 'Projects',
            resellers: 'Resellers',
            operations: 'Operations',
            tickets: 'Tickets',
            completedTickets: 'Completed Tickets',
            tasks: 'Tasks',
            appointments: 'Appointments',
            services: 'Services',
            quickActions: 'Quick Actions',
            newTicket: 'New Ticket',
            reports: 'Reports',
            analytics: 'Analytics'
          },
          
          // Navigation
          dashboard: 'Dashboard',
          tickets: 'Tickets',
          tasks: 'Tasks',
          employees: 'Employees',
          customers: 'Customers',
          resellers: 'Resellers',
          projects: 'Projects',
          services: 'Services',
          units: 'Units',
          notes: 'Notes',
          users: 'Users',
          logs: 'Logs',
          settings: 'Settings',
          
          // Ticket states
          states: {
            assignment: 'Awaiting Assignment',
            cancelled: 'Cancelled',
            deleted: 'DELETED',
            failed: 'Service Failed',
            in_queue: 'In Queue',
            in_progress: 'In Progress',
            approval: 'Awaiting Approval',
            completed: 'Completed',
            pending: 'Pending',
            sent_to_base: 'Sent to Service',
            sent_to_reseller: 'Sent to Reseller',
            received_by_base: 'Received by Service',
            received_by_reseller: 'Received by Reseller',
            eval_started: 'Under Review',
            pending_for_coverage: 'Service cost being determined',
            customer_accepted: 'Repair cost approved by customer',
            customer_rejected: 'Repair cost rejected by customer',
          },
          
          // Ticket kinds
          kinds: {
             education: 'Education',
             initialization: 'Initialization',
             installation: 'Installation',
             assembly: 'Assembly',
             malfunction: 'Malfunction',
             replacement: 'Replacement',
             maintenance: 'Maintenance',
             construction_site_control: 'Construction Site Control',
             infrastructure_control: 'Infrastructure Control',
             request: 'Request',
             other: 'Other',
           },
          
          // Priority levels
          priority: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
          },
          
          // Status labels
          status: {
            new: 'New',
            assigned: 'Assigned',
            in_progress: 'In Progress',
            completed: 'Completed',
            cancelled: 'Cancelled',
            unknown: 'Unknown',
          },
          
          // Messages
          messages: {
            customer_not_found_or_phone_not_verified: 'Customer not found or phone number not verified.',
            data_loading_error: 'An error occurred while loading data.',
            copied: 'Copied',
            message_template_copied: 'Message template copied to clipboard',
            error: 'Error',
            clipboard_copy_failed: 'Failed to copy to clipboard. Please copy the text manually.',
            success: 'Success',
            operation_failed: 'Operation could not be completed.',
            ticket_deleted: 'Ticket deleted.',
            ticket_started: 'Ticket started',
            ticket_completed: 'Ticket completed',
            ticket_cancelled: 'Ticket cancelled.',
            service_form_saved: 'Service form saved successfully',
            processing_operation: 'Processing operation...',
          },
          
          // Buttons
          buttons: {
            send_message_copy_to_clipboard: 'Send Message (Copy to Clipboard)',
          },
          
          // Validation messages
          validation: {
            phone_required: 'Phone number is required',
            phone_10_digits: 'Phone number must be 10 digits',
            phone_start_with_5: 'Phone number must start with 5',
          },
          
          // Forms
          forms: {
            phone_number: 'Phone Number',
          },
          
          // Tickets
          tickets: {
            created_successfully: 'Your Ticket Has Been Created',
            tracking_message: 'You can track the status of your service record at any time with this tracking number',
            go_to_query: 'Click here to go to the query screen.',
            create_ticket: 'Create Ticket',
            create_new_service_request: 'Create a new service request',
          },
          
          ticket: {
            header: {
              title: 'Title',
              status_label: 'Status',
              customer_label: 'Customer',
              reseller_label: 'Reseller',
              unit_label: 'Unit',
              created_label: 'Created',
              change: 'Change',
              assign: 'Assign',
              unassigned: 'Unassigned',
              date_not_specified: 'Date not specified'
            },
            tasks: {
              title: 'Tasks',
              subtitle: 'Tasks related to ticket',
              add_bulk: 'Add Bulk Tasks',
              add_subtask: 'Add Subtask',
              go_to_work_order: 'Go To Work Order'
            },
            statistics: {
              load_error: 'Statistics could not be loaded',
              missing_date_info: 'Ticket date information is missing',
              open_duration: 'Open Duration',
              last_update: 'Last Update',
              priority_label: 'Priority',
              progress_label: 'Progress',
              time_analysis: 'Time Analysis',
              performance_metrics: 'Performance Metrics',
              estimated_completion: 'Estimated Completion',
              created: 'Created',
              assigned_person: 'Assigned Person',
              task_count: 'Task Count',
              note_count: 'Note Count',
              update_count: 'Update Count',
              overdue_warning_title: 'Overdue Warning',
              overdue_warning_desc: 'This ticket exceeded the estimated completion time. Prioritize accordingly.'
            },
            timeline: {
              current_status: 'Current Status:',
              ticket_created: 'Ticket Created',
              ticket_assigned: 'Ticket Assigned',
              unit_assigned: 'Unit Assigned',
              ticket_started: 'Ticket Started',
              ticket_completed: 'Ticket Completed',
              ticket_cancelled: 'Ticket Cancelled',
              created_desc: 'created by',
              assigned_reseller_desc: 'assigned to reseller',
              assigned_unit_desc: 'assigned to unit',
              started_desc: 'Work order processing started',
              completed_desc: 'Work order successfully completed',
              cancelled_desc: 'Work order cancelled'
            },
            templates: {
              select_title: 'Select Template',
              select_subtitle: 'Choose a ticket template',
              load_error: 'Templates could not be loaded',
              not_selected: 'Template not selected',
              pdf_generated: 'PDF generated',
              docx_generated: 'DOCX generated',
              pdf_error: 'PDF generation error',
              docx_error: 'DOCX generation error'
            },
            form_labels: {
              customer_full_name: 'Customer Full Name',
              customer_address: 'Customer Address',
              customer_phone: 'Customer Phone',
              customer_email: 'Customer Email',
              faulty_product: 'Faulty Product',
              fault: 'Fault',
              description: 'Description',
              unit: 'Unit',
              product_name: 'Product Name',
              serial_number: 'Serial Number'
            },
            activity_history: 'Activity History'
          },
          
          customer: {
            customer: "Customer",
            contact: "Contact",
            reseller: "Reseller",
            status: "Status",
            actions: "Actions",
            unassigned: "Unassigned",
            view_details: "View Details",
            edit: "Edit",
            delete: "Delete",
            name: "Name",
            phone: "Phone",
            city: "City",
            verified: "Verified",
            customer_management: "Customer Management",
            customers_displayed: "customers displayed",
            customers: "Customers",
            new_customer: "New Customer",
            navigation_next: "Next",
            navigation_back: "Back",
            search_customer: "Search customer...",
            all_statuses: "All Statuses",
            unverified: "Unverified",
            no_customers_found: "No customers found matching search criteria",
            no_customers_yet: "No customers yet",
            try_different_search: "Try different search terms",
            add_first_customer_hint: "Use the button above to add your first customer",
            add_first_customer: "Add First Customer"
          },
          
          // Dashboard
          dashboard_summary: 'Summary',
          management_dashboard: 'Management Dashboard',
          general_statistics: 'General Statistics',
          total_tickets: 'Total Tickets',
          task_count: 'Task Count',
          customer_count: 'Customer Count',
          employee_count: 'Employee Count',
          ticket_status_distribution: 'Ticket Status Distribution (%)',
          
          // Dashboard statistics
          total_customers: "Total Customers",
          total_tickets: "Total Tickets",
          open_tickets: "Open Tickets",
          closed_tickets: "Closed Tickets",
          
          // Employee translations
          employee: {
            employee_management: "Employee Management",
            team_members_info: "Team members and team information",
            create_team: "Create Team",
            add_employee: "Add Employee",
            name: "Full Name",
            dealer: "Dealer",
            dealer_manager: "Dealer Manager?",
            employee_action: "Employee Action",
            team: "Team",
            team_leader: "Team Leader?",
            team_action: "Team Action",
            availability: "Availability",
            add_to_team: "Add to Team",
            remove_from_team: "Remove from Team",
            no_employees_yet: "No employees found yet",
            add_first_employee_hint: "Use the button above to add your first employee",
            employee_removed_from_team: "Employee removed from team",
            remove_from_team_failed: "Failed to remove from team",
            roles: "Roles",
            teams: "Teams",
            person_info: "Personnel Information",
            manager_label: "Manager",
            worker_label: "Employee",
            team_leader_label: "Team Leader",
            no_team: "No Team",
            login_permission: "Login Permission",
            login_permission_enabled: "Login permission enabled",
            login_permission_disabled: "Login permission disabled",
            no_employees_found: "No employees found matching search criteria",
            search_employee: "Search employee...",
            make_manager: "Make Manager",
            remove_manager_privilege: "Remove Manager Privilege",
            toggle_servicer_status: "Toggle Servicer Status"
          },
          login: {
            title: 'Sign In',
            back: 'Go back',
            subtitle: 'Enter your username and sign in with SMS verification.',
            username: 'Username',
            username_placeholder: 'Your username',
            reseller_code: 'Reseller Code',
            reseller_code_placeholder: 'Reseller code',
            sms_code: 'SMS Code',
            sms_code_placeholder: 'Code received via SMS',
            twofa_hint_sms: 'Code was sent via SMS, please check your SMS.',
            twofa_hint_email: 'Code was sent via email, please check your inbox.',
            remember_me: 'Remember me',
            continue: 'Continue',
            verify_sms: 'Verify SMS',
            resend_sms: 'Resend SMS',
            try_sms: 'Try via SMS',
            try_email: 'Try via Email',
            username_help: 'Enter your username and continue.',
            reseller_code_help: 'Enter the reseller code.',
            sms_resend_success: 'SMS resent',
            email_resend_success: 'Email resent',
            errors: {
              username_required: 'Please enter your username.',
              reseller_code_required: 'Please enter reseller code.',
              sms_code_required: 'Please enter SMS code.',
              invalid_username: 'Invalid username.',
              sms_verification_failed: 'SMS verification failed.',
              sms_resend_failed: 'Failed to send SMS.',
              email_resend_failed: 'Failed to send email.'
            },
            admin: {
              title: 'Reseller Management',
              city: 'City',
              new_reseller: 'New Reseller',
              move_to_root_hint: 'Drop here to move to root (no parent reseller)',
              move_to_root_label: 'Move To Root (No Parent)',
              table: {
                name: 'Name',
                cities: 'Cities',
                open_ticket: 'Open Tickets',
                managers: 'Managers',
                status: 'Status'
              },
              drag_assign_hint: 'Drag and drop onto another reseller to assign parent',
              deactivate: 'Deactivate',
              activate: 'Activate',
              edit_reseller: 'Edit Reseller',
              create: 'Create',
              export: {
                filename: 'resellers_admin',
                sheet_name: 'Resellers',
                columns: {
                  id: 'ID',
                  name: 'Name',
                  cities: 'Cities',
                  open_ticket: 'Open Tickets',
                  managers: 'Managers',
                  status: 'Status'
                }
              }
            }
          },
          project: {
        project_management: "Project Management",
        active_projects_info: "Active projects and progress status",
        add_project: "Add Project",
        search_project: "Search project...",
        all: "All",
        active: "Active",
        completed: "Completed",
        unit_count: "Unit Count",
        completion: "Completion",
        work_orders: "Work Orders",
        open: "Open",
        closed: "Closed",
        no_projects_found: "No projects found matching search criteria",
        no_projects_yet: "No projects found yet",
        try_different_search: "Try different search terms",
        add_first_project_hint: "Use the button above to add your first project"
      },
      task: {
        type: "TYPE",
        title: "Title",
        team: "Team",
        created_date: "Created Date",
        appointment: "Appointment",
        status: "Status",
        progress_expectation: "Progress Expectation",
        total_tasks: "Total {{count}} tasks"
      },
      service: {
        unit: "UNIT",
        unit_label: "Unit",
        faulty_products: "Faulty products belonging to unit",
        faulty_products_count: "{{count}} Faulty Products",
        no_service_record: "No Service Record",
        click_for_details: "Click to view details",
        device: "DEVICE",
        type: "TYPE",
        description: "DESCRIPTION",
        status: "STATUS",
        service_management: "Service Management",
        active_service_records: "Active service records and faulty products",
        no_service_records_yet: "No service records found yet",
        new_work_orders_appear_here: "New work orders will appear here"
      },
          
          // Project kinds
          projectKinds: {
            collective: 'Collective Housing',
            villa: 'Villa',
            factory: 'Factory',
            office: 'Office',
            hotel: 'Hotel',
            eatery: 'Cafeteria',
            bs_center: 'Business Center',
            pl_bldng: 'Public Building',
            sp_center: 'Shopping Center',
            other: 'Other',
          },
          
          // Service types
          serviceTypes: {
            renovation: 'Repair/Renovation',
            replacement: 'Replacement',
            maintenence: 'Maintenance',
          },
          
          // Coverage
          coverage: {
            guarantee: 'Warranty Coverage',
            customer: 'User Error (Customer)',
            reseller: 'Installation Error (Reseller)',
          },

          reseller: {
            management_system_title: 'Reseller Management System',
            management_system_subtitle: 'Manage all resellers and work orders from one place',
            total_resellers: 'Total Resellers',
            active_resellers: 'Active Resellers',
            open_work_orders: 'Open Work Orders',
            manager_summary: 'Manager Summary',
            level_main: 'Main Reseller',
            level_region: 'Regional Reseller',
            level_sub: 'Sub Reseller',
            expand_all: 'Expand All',
            collapse_all: 'Collapse All',
            expand: 'Expand',
            collapse: 'Collapse',
            open_tickets: 'Open Tickets',
            team_count: 'Team Count',
            manager_title: 'Reseller Manager',
            phone_number_title: 'Reseller Phone Number',
            address_title: 'Reseller Address',
            modal_manager_summary_title: 'Reseller Manager Summary',
            modal_total_resellers: 'Total Resellers',
            modal_total_managers: 'Total Managers',
            modal_resellers_without_manager: 'Resellers Without Manager',
            resellers_without_managers_title: 'Resellers Without Managers',
            manager_count_by_reseller: 'Manager Counts by Reseller',
            reseller: 'Reseller',
            manager_count: 'Manager Count',
            close: 'Close',
            export: {
              filename: 'resellers',
              sheet_name: 'Resellers',
              columns: {
                reseller: 'Reseller',
                level: 'Level',
                phone: 'Phone',
                address: 'Address',
                city: 'City',
                open_work_order: 'Open Work Order',
                team_count: 'Team Count',
                manager_count: 'Manager Count'
              }
            }
          },
        }
      }
    }
  });

export default i18n;
